import React from "react";
import PropTypes from "prop-types";
import {TableRow, TableCell, Typography, makeStyles} from '@material-ui/core';

const useStyles = makeStyles(() => ({
    row: {

    },
    cell: {
        textAlign: "center",
    },
}));

const CarDetailsRow = props => {
    const defaultClasses = useStyles();
    const { registrationNo, brand, model, description, onRowClick,
            onLastCellClick, classes = {...defaultClasses}, lastCellContent
        } = props;

    return (
        <TableRow
            className={classes.row}
            onClick={onRowClick}
        >
            <TableCell className={classes.cell}>
                <Typography
                    variant="body1"
                >
                    {registrationNo}
                </Typography>
            </TableCell>
            <TableCell className={classes.cell}>
                <Typography
                    variant="body1"
                >
                    {brand}
                </Typography>
            </TableCell>
            <TableCell className={classes.cell}>
                <Typography
                    variant="body1"
                >
                    {model}
                </Typography>
            </TableCell>
            <TableCell className={classes.cell}>
                <Typography
                    variant="body1"
                >
                    {description}
                </Typography>
            </TableCell>
            <TableCell
                className={classes.cell}
                style={{cursor: "pointer"}}
                onClick={onLastCellClick}
            >
                {lastCellContent}
            </TableCell>
        </TableRow>
    );
};

export default CarDetailsRow;

CarDetailsRow.propTypes = {
    registrationNo: PropTypes.string,
    brand: PropTypes.string,
    model: PropTypes.string,
    description: PropTypes.string,
    onRowClick: PropTypes.func,
    onLastCellClick: PropTypes.func,
    classes: PropTypes.object,
    lastCellContent: PropTypes.node
};